import React from "react";
import {Link} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../LayoutAside"
import UI from "components/UI"
import StringUtil from "../../../utils/StringUtil";
import TbComFile from "../../../domain/main/com/file/TbComFile";

export default ContentsContainer;

function ContentsContainer(props: any) {
    const [uploadId, setUploadId] = React.useState("");
    const [inputFileValue, setInputFileValue] = React.useState<TbComFile>();
    const logDiv = React.useRef(null as unknown as HTMLDivElement);

    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

    const onUploadComplete = (uploadID: string) => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadID);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;


        logDiv.current.innerHTML += newFilesInfo(arrayNew);
        logDiv.current.innerHTML += delFilesInfo(arrayDel);
    }

    const newFilesInfo = (arrayNew?: any[]) => {

        var str = '-- 업로드 파일 정보 시작 --<br/>';
        str += StringUtil.rightPad('RealFileName', 20, ' ') + ' : {0}<br/>';
        str += StringUtil.rightPad('ServerFileName', 20, ' ') + ' : {1}<br/>';
        str += StringUtil.rightPad('IsLargeFile', 20, ' ') + ' : {2}<br/>';
        str += StringUtil.rightPad('Size', 20, ' ') + ' : {3}<br/>';
        str += StringUtil.rightPad('UploadPath', 20, ' ') + ' : {4}<br/>';
        str += StringUtil.rightPad('LogicalPath', 20, ' ') + ' : {5}<br/>';
        str += StringUtil.rightPad('fileExtention', 20, ' ') + ' : {6}<br/>';
        str += StringUtil.rightPad('LocalPath', 20, ' ') + ' : {7}<br/>';
        str += StringUtil.rightPad('CustomValue', 20, ' ') + ' : {8}<br/>';
        str += StringUtil.rightPad('ResponseCustomValue', 20, ' ') + ' : {9}<br/>';
        str += StringUtil.rightPad('Order', 20, ' ') + ' : {10}<br/>';
        str += '-- 업로드 파일 정보 끝 --<br/>';

        let originalName = '';
        let uploadName = '';
        let size = '';
        let uploadPath = '';
        let logicalPath = '';
        let fileExtension = '';
        let localPath = '';
        let customValue = '';
        let responseCustomValue = '';
        let order = '';
        let isLargeFile = '';

        arrayNew?.forEach((item, index) => {
            originalName += item.originalName;
            uploadName += item.uploadName;
            isLargeFile += item.isLargeFile;
            size += item.size;
            uploadPath += item.uploadPath;
            logicalPath += item.logicalPath;
            fileExtension += item.extension;
            localPath += item.localPath;
            customValue += item.customValue;
            responseCustomValue += item.responseCustomValue;
            order += item.order;

            if (index !== arrayNew?.length - 1) {
                originalName += ',';
                uploadName += ',';
                size += ',';
                uploadPath += ',';
                logicalPath += ',';
                fileExtension += ',';
                localPath += ',';
                customValue += ',';
                responseCustomValue += ',';
                order += ',';
                isLargeFile += ',';
            }

        })

        str = str.replace('{0}', originalName);
        str = str.replace('{1}', uploadName);
        str = str.replace('{2}', isLargeFile);
        str = str.replace('{3}', size);
        str = str.replace('{4}', uploadPath);
        str = str.replace('{5}', logicalPath);
        str = str.replace('{6}', fileExtension);
        str = str.replace('{7}', localPath);
        str = str.replace('{8}', customValue);
        str = str.replace('{9}', responseCustomValue);
        str = str.replace('{10}', order);

        return str;
    }

    const delFilesInfo = (arrayDel?: any[]) => {
        let str = '-- 삭제된 파일 정보 --<br/>';
        str += StringUtil.rightPad('Key', 8, ' ') + ' : {0}<br/>';
        str += StringUtil.rightPad('FileName', 8, ' ') + ' : {1}<br/>';
        str += StringUtil.rightPad('Size', 8, ' ') + ' : {2}<br/><br/>';
        str += '-- 삭제된 파일 정보 끝 --<br/>';

        let sUniqKey = '';
        let sOriginalName = '';
        let sSize = '';

        arrayDel?.forEach((item, index) => {
            sUniqKey += item.uniqKey;
            sOriginalName += item.originalName;
            sSize += item.size;

            if (index !== arrayDel?.length - 1) {
                sUniqKey += ',';
                sOriginalName += ',';
                sSize += ',';
            }
        })

        str = str.replace('{0}', sUniqKey);
        str = str.replace('{1}', sOriginalName);
        str = str.replace('{2}', sSize);

        return str;
    }

    const buttonClick = async () => {
        window["RAONKUPLOAD"].Transfer(uploadId);
    }

    const inputFileValueChanged = (value: TbComFile) => {
        console.log("inputFileValueChanged", value)
        setInputFileValue(value)
    }

    return (
        <PageContainer session={false}>
            <LayoutAside/>
            <div className="fww-con">
                <ul className="fww-brd">
                    <li><Link to="/example">홈</Link></li>
                    <li><Link to="#">KUpload</Link></li>
                </ul>
                <h1 className="tx tx-hd2">Raon k-Upload Sample</h1>
                <h2 className="tx tx-hd3">다건 처리</h2>
                <div className="inner">
                    <div className="fo-item">
                        <p className="fo-key">파일업로드</p>

                        <UI.FileUpload
                            onCreationComplete={onCreationComplete}
                            onUploadComplete={onUploadComplete}
                            attrs={{
                                MaxTotalFileCount: "1",
                                ExtensionAllowOrLimit: "1"
                            }}
                        />
                    </div>
                </div>
                <div className="hz-root hz-right hz-gap8 mb25">
                    <div>{uploadId}</div>
                </div>
                <div className="hz-root hz-left hz-gap8 mb25">
                    <div ref={logDiv}></div>
                </div>

                <div className="hz-root hz-right hz-gap8 mb25">
                    <button onClick={buttonClick}>등록</button>
                </div>
                <h2 className="tx tx-hd3">단건 처리</h2>
                <form className="fo fo-col2 mb30" name="" action="" method="">
                    <div className="inner">
                        <div className="fo-item fo-m-1-3 req">

                            <div className="fo-value">

                                <UI.InputFile
                                    className={"w100p"}
                                    placeholder={'이미지 파일을 첨부해 주세요(jpg, gif, png 파일)'}
                                    valueChanged={inputFileValueChanged}/>
                            </div>
                        </div>
                        <div className="fo-item fo-m-1-3 req">
                            <UI.FileDownload
                                value={inputFileValue}
                                className={"w100p"}
                                onError={(uploadID, paramObj) => {
                                    console.log(uploadID, paramObj);
                                }}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </PageContainer>
    );
}
